var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//This Container represents the navigation bar which always sits
//To the far left of the dashboard and other pages
import { BoxIcon, CogIcon, DiagramTreeIcon, HomeIcon, InboxSearchIcon, ManualIcon, MenuClosedIcon, MenuIcon, Pane, Paragraph, RouteIcon, ShoppingCartIcon, StarIcon, TrendingUpIcon, } from "evergreen-ui";
import "firebase/auth";
import { memo, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { SidebarContext } from "../contexts/SidebarContext";
var LinkBox = function (_a) {
    var children = _a.children, route = _a.route, expanded = _a.expanded, label = _a.label, outbound = _a.outbound, newTab = _a.newTab;
    var location = useLocation();
    var _b = useState(false), hover = _b[0], setHover = _b[1];
    if (outbound) {
        return (_jsx("a", __assign({ style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                textDecoration: "none",
            }, href: route, target: newTab ? "_blank" : undefined, rel: "noreferrer" }, { children: _jsxs(Pane, __assign({ onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, style: {
                    opacity: hover ? 0.5 : 1,
                    display: "flex",
                    flexDirection: "row",
                    marginTop: 15,
                    padding: 15,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: expanded ? "space-between" : "center",
                    backgroundColor: location.pathname === route ? "#49beef10" : "rgba(0,0,0,0)",
                    cursor: "pointer",
                    borderRightWidth: location.pathname === route ? 2 : 0,
                    borderLeftWidth: 0,
                    borderTopWidth: 0,
                    borderBottomWidth: 0,
                    borderStyle: "solid",
                    borderColor: "#49beef",
                } }, { children: [children, expanded && (_jsx(Paragraph, __assign({ textAlign: "right", className: "bodytext", fontSize: 12 }, { children: label })))] })) })));
    }
    return (_jsx(Link, __assign({ style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            textDecoration: "none",
        }, to: route }, { children: _jsxs(Pane, __assign({ onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, style: {
                opacity: hover ? 0.5 : 1,
                display: "flex",
                flexDirection: "row",
                marginTop: 15,
                padding: 15,
                width: "100%",
                alignItems: "center",
                justifyContent: expanded ? "space-between" : "center",
                backgroundColor: location.pathname === route ? "#49beef10" : "rgba(0,0,0,0)",
                cursor: "pointer",
                borderRightWidth: location.pathname === route ? 2 : 0,
                borderLeftWidth: 0,
                borderTopWidth: 0,
                borderBottomWidth: 0,
                borderStyle: "solid",
                borderColor: "#49beef",
            } }, { children: [children, expanded && (_jsx(Paragraph, __assign({ textAlign: "right", className: "bodytext", fontSize: 12 }, { children: label })))] })) })));
};
var NavigatorBar = memo(function () {
    var location = useLocation();
    var state = useContext(SidebarContext).state;
    var isSidebarExpanded = state[0], setSidebarExpanded = state[1];
    return (_jsxs(Pane, __assign({ style: {
            height: "100vh",
            zIndex: 10,
            width: isSidebarExpanded ? 200 : 65,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: 35,
            paddingBottom: 35,
            transition: "200ms ease",
            backgroundColor: "white",
        }, elevation: 2 }, { children: [isSidebarExpanded ? (_jsxs(Pane, __assign({ style: {
                    width: "80%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    cursor: "pointer",
                } }, { children: [_jsx("img", { src: logo, style: { height: 30 }, alt: "apomap-logo" }), _jsx(MenuClosedIcon, { onClick: function () { return setSidebarExpanded(!isSidebarExpanded); }, color: "#12183E" })] }))) : (_jsx(MenuIcon, { style: { cursor: "pointer" }, onClick: function () { return setSidebarExpanded(!isSidebarExpanded); }, color: "#12183E" })), _jsxs(Pane, __assign({ style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                } }, { children: [_jsx(LinkBox, __assign({ label: "Jetzt upgraden", expanded: isSidebarExpanded, route: "/upgrade" }, { children: _jsx(ShoppingCartIcon, { color: "#F4BA69" }) })), _jsx(LinkBox, __assign({ label: "Dashboard", expanded: isSidebarExpanded, route: "/dashboard" }, { children: _jsx(HomeIcon, { color: location.pathname === "/dashboard" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Tourenplanung", expanded: isSidebarExpanded, route: "/tourplanning" }, { children: _jsx(RouteIcon, { color: location.pathname === "/tourplanning" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Packmodus", expanded: isSidebarExpanded, route: "/pack" }, { children: _jsx(BoxIcon, { color: location.pathname === "/pack" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Favoriten", expanded: isSidebarExpanded, route: "/favorites" }, { children: _jsx(StarIcon, { color: location.pathname === "/favorites" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Dokumentation", expanded: isSidebarExpanded, route: "/documentation" }, { children: _jsx(InboxSearchIcon, { color: location.pathname === "/documentation" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Statistiken", expanded: isSidebarExpanded, route: "/analytics" }, { children: _jsx(TrendingUpIcon, { color: location.pathname === "/analytics" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Automatisierung", expanded: isSidebarExpanded, route: "/automate" }, { children: _jsx(DiagramTreeIcon, { color: location.pathname === "/automate" ? "#49beef" : "#2D3B51" }) })), _jsx(LinkBox, __assign({ label: "Handbuch", expanded: isSidebarExpanded, route: "//apomap.de/handbuch", outbound: true, newTab: true }, { children: _jsx(ManualIcon, { color: "#2D3B51" }) }))] })), _jsx(LinkBox, __assign({ label: "Einstellungen", expanded: isSidebarExpanded, route: "/settings" }, { children: _jsx(CogIcon, { color: location.pathname === "/settings" ? "#49beef" : "#2D3B51" }) }))] })));
}, function () { return true; });
export default NavigatorBar;
